import {
  FormEvent,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from 'react'
import { useHistory } from 'react-router-dom'
import { PasswordTips } from '../PasswordTips'
import services from '../../auth-services'
import { checkPasswordStrength } from '@/utils/password'
import { removeCache } from '@/utils/cache'
import useStyles from './styles'
import {
  InputPassword,
  Text,
  Button,
  toast,
  InputPasswordProps,
} from '@conexasaude/conexa-hero'
import ClariHelper from '@/components/Clari'

const ChangePasswordForm: FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [password, setPassword] = useState<string>()
  const [confirmPassword, setConfirmPassword] = useState<string>()
  const [passwordStrength, setPasswordStrength] =
    useState<InputPasswordProps['strength']>()
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false)

  const history = useHistory()

  const styles = useStyles()

  const changePassword = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsFormSubmitted(true)
    setIsLoading(true)

    if (passwordStrength !== 'strong') {
      toast({
        message:
          'Sua senha está fraca, siga nossas dicas para uma senha mais segura',
        variant: 'error',
        autoCloseDuration: 5000,
      })
      setIsLoading(false)

      return
    }

    if (password !== confirmPassword) {
      setIsLoading(false)

      return
    }

    try {
      await services.changePassword(password, confirmPassword)

      removeCache('passwordConfirmed')

      history.push('/trocar-senha/sucesso', {
        passwordChanged: true,
      })
    } catch (err) {
      const errMessage =
        err?.response?.data?.object?.msg ||
        err?.response?.data?.msg ||
        err?.message

      toast({
        message: errMessage,
        variant: 'error',
        autoCloseDuration: 5000,
      })
    }

    setIsLoading(false)
  }

  useEffect(() => {
    if (password) {
      const strength = checkPasswordStrength(password)

      setPasswordStrength(strength)

      return
    }

    setPassword(null)
    setPasswordStrength(null)
  }, [password])

  return (
    <Fragment>
      <form css={styles.container} onSubmit={changePassword}>
        <Text renderAs="h2">Criar nova senha</Text>
        <Text renderAs="p">Dicas para criar uma senha forte e segura:</Text>

        <PasswordTips password={password} />

        <div css={styles.inputWrapper}>
          <InputPassword
            label="Nova senha"
            placeholder="Informe a nova senha"
            onChange={event => setPassword(event.target.value)}
            fullWidth
            strength={passwordStrength}
          />
        </div>

        <div css={styles.inputWrapper}>
          <InputPassword
            label="Confirmar nova senha"
            placeholder="Confirme a nova senha"
            onChange={event => setConfirmPassword(event.target.value)}
            fullWidth
            {...(isFormSubmitted &&
              password !== confirmPassword && {
                error: 'As senhas estão diferentes',
              })}
          />
        </div>

        <div css={styles.buttonWrapper}>
          <Button busy={isLoading} disabled={isLoading} fullWidth>
            Criar senha
          </Button>
        </div>
      </form>

      <ClariHelper showShotcut={false} />
    </Fragment>
  )
}

export { ChangePasswordForm }
